import { render, staticRenderFns } from "./DetailPaymentCheckout.vue?vue&type=template&id=af5c8916&"
import script from "./DetailPaymentCheckout.vue?vue&type=script&lang=js&"
export * from "./DetailPaymentCheckout.vue?vue&type=script&lang=js&"
import style0 from "./DetailPaymentCheckout.vue?vue&type=style&index=0&id=af5c8916&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports